import { render, staticRenderFns } from "./NoticeOfLeave.vue?vue&type=template&id=52efd278&scoped=true&"
import script from "./NoticeOfLeave.vue?vue&type=script&lang=ts&"
export * from "./NoticeOfLeave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efd278",
  null
  
)

export default component.exports